module.exports = "https://assets.bwbx.io/s3/reg2/images/apple-pay-mark-2e68b436d6c69eeeb3e5.svg";